import React from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import About from './About';
import TechnicalSkills from './TechnicalSkills';
import Experience from './Experience';
import Projects from './Projects';
import Education from './Education';
import Certifications from './Certifications';
import Contact from './Contact';

const Portfolio = () => {
  return (
    <div className="portfolio">
      <Navigation />
      <Hero />
      <About />
      <TechnicalSkills />
      <Experience />
      <Projects />
      <Education />
      <Certifications />
      <Contact />
    </div>
  );
};

export default Portfolio;